


const flavors = {
    nuts: [
        { id: 'nut-almond', name: 'Almond' },
        { id: 'nut-pistachio', name: 'Pistachio' },
        { id: 'nut-hazelnut', name: 'Hazelnut' },
        { id: 'nut-walnut', name: 'Walnut' },
        { id: 'nut-pecan', name: 'Pecan' },
    ],
    berries: [
        { id: 'berry-strawberry', name: 'Strawberry' },
        { id: 'berry-raspberry', name: 'Raspberry' },
        { id: 'berry-blueberry', name: 'Blueberry' },
        { id: 'berry-blackberry', name: 'Blackberry' },
        { id: 'berry-cherry', name: 'Cherry' },
    ],
    fruits: [
        { id: 'fruit-lemon', name: 'Lemon' },
        { id: 'fruit-orange', name: 'Orange' },
        { id: 'fruit-passionfruit', name: 'Passion Fruit' },
        { id: 'fruit-mango', name: 'Mango' },
        { id: 'fruit-apple', name: 'Apple' },
    ],
    gourmet: [
        { id: 'gourmet-vanilla', name: 'Vanilla' },
        { id: 'gourmet-chocolate', name: 'Chocolate' },
        { id: 'gourmet-coffee', name: 'Coffee' },
        { id: 'gourmet-caramel', name: 'Caramel' },
        { id: 'gourmet-rose', name: 'Rose' },
    ],
};

const allFlavors = [
    { id: 'flavor-none', name: 'None' },
    ...flavors.gourmet,
    ...flavors.nuts,
    ...flavors.berries,
    ...flavors.fruits,
];

export const customizationGroups = {
    // General
    nuts: {
        id: 'nuts',
        name: 'Flavor',
        options: flavors.nuts,
    },
    // Macarons
    macaronShell: {
        id: 'macaron-shell',
        name: 'Shell Flavor',
        options: [
            { id: 'macaron-shell-natural', name: 'Natural' },
            ...allFlavors.filter(f => f.id !== 'flavor-none')
        ],
    },
    macaronFilling: {
        id: 'macaron-filling',
        name: 'Filling',
        options: allFlavors.filter(f => f.id !== 'flavor-none'),
    },
    macaronHeart: {
        id: 'macaron-heart',
        name: 'Center',
        options: [
            { id: 'macaron-heart-none', name: 'None' },
            { id: 'macaron-heart-fondant', name: 'Fondant Heart' },
            { id: 'macaron-heart-croquant', name: 'Croquant Heart' },
            { id: 'macaron-heart-jam', name: 'Fruit Jam' },
        ],
    },
    // Cupcakes
    cupcakeBase: {
        id: 'cupcake-base',
        name: 'Base Flavor',
        options: [
            ...flavors.gourmet.filter(f => f.id !== 'gourmet-rose' && f.id !== 'gourmet-coffee'),
            ...flavors.nuts.slice(0,2),
            ...flavors.berries,
        ]
    },
    cupcakeFrostingType: {
        id: 'cupcake-frosting-type',
        name: 'Frosting Type',
        options: [
            { id: 'frosting-buttercream', name: 'Buttercream' },
            { id: 'frosting-ganache', name: 'Ganache' },
            { id: 'frosting-cream-cheese', name: 'Cream Cheese' },
        ]
    },
    cupcakeFrostingFlavor: {
        id: 'cupcake-frosting-flavor',
        name: 'Frosting Flavor',
        options: allFlavors.filter(f => f.id !== 'flavor-none')
    },
     cupcakeTopperType: {
        id: 'cupcake-topper-type',
        name: 'Topper Type',
        options: [
            { id: 'topper-type-none', name: 'None' },
            { id: 'topper-type-sprinkles', name: 'Sprinkles' },
            { id: 'topper-type-buttercream', name: 'Buttercream' },
            { id: 'topper-type-cream-cheese', name: 'Cream Cheese' },
            { id: 'topper-type-ganache', name: 'Ganache' },
            { id: 'topper-type-fondant', name: 'Fondant' },
        ]
    },
    cupcakeTopperShape: {
        id: 'cupcake-topper-shape',
        name: 'Topper Shape',
        options: [
             { id: 'topper-shape-simple-swirl', name: 'Simple Swirl' },
             { id: 'topper-shape-rose', name: 'Buttercream Rose' },
             { id: 'topper-shape-fondant-flower', name: 'Fondant Flower (Fondant Only)' },
             { id: 'topper-shape-fondant-mermaid', name: 'Fondant Mermaid Tail (Fondant Only)' },
             { id: 'topper-shape-fondant-custom', name: 'Custom Fondant Shape (Fondant Only)' },
        ]
    },
    // Madeleines
    madeleineBase: {
        id: 'madeleine-base',
        name: 'Base Flavor',
        options: [
            { id: 'madeleine-base-natural', name: 'Natural' },
            ...allFlavors.filter(f => f.id !== 'flavor-none')
        ]
    },
    madeleineCoatingType: {
        id: 'madeleine-coating-type',
        name: 'Coating Type',
        options: [
            { id: 'coating-type-none', name: 'None' },
            { id: 'coating-type-glaze', name: 'Glaze' },
            { id: 'coating-type-ganache', name: 'Ganache' },
        ]
    },
    madeleineCoatingFlavor: {
        id: 'madeleine-coating-flavor',
        name: 'Coating Flavor',
        options: allFlavors,
    },
    madeleineFillingType: {
        id: 'madeleine-filling-type',
        name: 'Filling Type',
        options: [
            { id: 'filling-type-none', name: 'None' },
            { id: 'filling-type-custard', name: 'Custard Cream' },
            { id: 'filling-type-buttercream', name: 'Buttercream' },
            { id: 'filling-type-cream-cheese', name: 'Cream Cheese' },
            { id: 'filling-type-ganache', name: 'Ganache' },
        ]
    },
    madeleineFillingFlavor: {
        id: 'madeleine-filling-flavor',
        name: 'Filling Flavor',
        options: allFlavors,
    },
    // Viennoiserie
    viennoiserieType: {
        id: 'viennoiserie-type',
        name: 'Type',
        options: [
            { id: 'viennoiserie-croissant', name: 'Croissant' },
            { id: 'viennoiserie-pain-choc', name: 'Pain au Chocolat' },
            { id: 'viennoiserie-schnecke', name: 'Schnecke' },
            { id: 'viennoiserie-pain-suisse', name: 'Pain Suisse' },
            { id: 'viennoiserie-chausson-pommes', name: 'Chausson aux Pommes' },
            { id: 'viennoiserie-neapolitan', name: 'Neapolitan' },
        ]
    },
    viennoiserieFilling: {
        id: 'viennoiserie-filling',
        name: 'Filling',
        options: allFlavors
    },
    viennoiserieTopping: {
        id: 'viennoiserie-topping',
        name: 'Topping',
        options: allFlavors
    },
    // Cakes
    cakeTiers: {
        id: 'cake-tiers',
        name: 'Tiers',
        options: [
            { id: 'tiers-1', name: '1 Tier' },
            { id: 'tiers-2', name: '2 Tiers' },
            { id: 'tiers-3', name: '3 Tiers' },
            { id: 'tiers-4', name: '4 Tiers' },
        ]
    },
    cakeFlavor: {
        id: 'cake-flavor',
        name: 'Cake Flavor',
        options: allFlavors.filter(f => f.id !== 'flavor-none')
    },
    cakeFillingType1: {
        id: 'cake-filling-type-1',
        name: 'Filling 1 Type',
        options: [
            { id: 'cake-filling-none', name: 'None' },
            { id: 'cake-filling-buttercream', name: 'Buttercream' },
            { id: 'cake-filling-ganache', name: 'Ganache' },
            { id: 'cake-filling-jam', name: 'Fruit Jam' },
            { id: 'cake-filling-croquant', name: 'Croquant' },
        ]
    },
    cakeFillingFlavor1: {
        id: 'cake-filling-flavor-1',
        name: 'Filling 1 Flavor',
        options: allFlavors.filter(f => f.id !== 'flavor-none'),
    },
    cakeFillingType2: {
        id: 'cake-filling-type-2',
        name: 'Filling 2 Type',
        options: [
            { id: 'cake-filling-none', name: 'None' },
            { id: 'cake-filling-buttercream', name: 'Buttercream' },
            { id: 'cake-filling-ganache', name: 'Ganache' },
            { id: 'cake-filling-jam', name: 'Fruit Jam' },
            { id: 'cake-filling-croquant', name: 'Croquant' },
        ]
    },
    cakeFillingFlavor2: {
        id: 'cake-filling-flavor-2',
        name: 'Filling 2 Flavor',
        options: allFlavors.filter(f => f.id !== 'flavor-none'),
    },
    cakeDecorationType: {
        id: 'cake-decoration-type',
        name: 'Decoration Type',
        options: [
            { id: 'decor-type-buttercream', name: 'Buttercream' },
            { id: 'decor-type-cream-cheese', name: 'Cream Cheese' },
            { id: 'decor-type-fondant', name: 'Fondant' },
            { id: 'decor-type-ganache', name: 'Ganache' },
        ]
    },
    cakeInspirationImages: {
        id: 'cake-inspiration-images',
        name: 'Inspiration Images',
        options: [], // This is a special case handled by a file input
    },
    // Choux & Eclairs
    chouxEclairType: {
        id: 'choux-eclair-type',
        name: 'Type',
        options: [
            { id: 'choux', name: 'Choux' },
            { id: 'eclair', name: 'Éclair' },
        ]
    },
    chouxEclairBaseFlavor: {
        id: 'choux-eclair-base-flavor',
        name: 'Base Flavor',
        options: [
            { id: 'choux-eclair-base-natural', name: 'Natural' },
            ...allFlavors.filter(f => f.id !== 'flavor-none')
        ]
    },
    chouxEclairFillingType: {
        id: 'choux-eclair-filling-type',
        name: 'Filling Type',
        options: [
            { id: 'filling-ganache', name: 'Ganache' },
            { id: 'filling-custard', name: 'Custard Cream' },
            { id: 'filling-buttercream', name: 'Buttercream' },
        ]
    },
    chouxEclairFillingFlavor: {
        id: 'choux-eclair-filling-flavor',
        name: 'Filling Flavor',
        options: allFlavors.filter(f => f.id !== 'flavor-none')
    },
    chouxEclairToppingFlavor: {
        id: 'choux-eclair-topping-flavor',
        name: 'Topping Flavor (Éclair only)',
        options: allFlavors,
    },
    // Savory Bites
    empanadaCookingMethod: {
        id: 'empanada-cooking-method',
        name: 'Cooking Method',
        options: [
            { id: 'empanada-fried', name: 'Fried' },
            { id: 'empanada-baked', name: 'Oven Baked' },
        ],
    },
    empanadaFilling: {
        id: 'empanada-filling',
        name: 'Filling',
        options: [
            { id: 'empanada-filling-beef', name: 'Spiced Beef & Egg' },
            { id: 'empanada-filling-chicken', name: 'Chicken & Olive' },
            { id: 'empanada-filling-spinach', name: 'Spinach & Ricotta' },
            { id: 'empanada-filling-tuna-paprika', name: 'Tuna & Grilled Paprika' },
            { id: 'empanada-filling-tuna-bechamel', name: 'Tuna & Béchamel' },
            { id: 'empanada-filling-shrimp', name: 'Garlic Shrimp' },
            { id: 'empanada-filling-corn', name: 'Corn & Cheese (Humita)' },
            { id: 'empanada-filling-mushroom', name: 'Mushroom & Leek (Vegan)' },
        ],
    },
    croquetteType: {
        id: 'croquette-type',
        name: 'Variety',
        options: [
            { id: 'croquette-ham', name: 'Jamón Serrano' },
            { id: 'croquette-mushroom', name: 'Mushroom & Truffle' },
            { id: 'croquette-cod', name: 'Salted Cod (Bacalao)' },
            { id: 'croquette-chicken', name: 'Creamy Chicken' },
            { id: 'croquette-shrimp', name: 'Shrimp' },
        ],
    },
    tapasType: {
        id: 'tapas-type',
        name: 'Tapa',
        options: [
            { id: 'tapas-patatas-bravas', name: 'Patatas Bravas' },
            { id: 'tapas-gambas-al-ajillo', name: 'Gambas al Ajillo (Garlic Shrimp)' },
            { id: 'tapas-pimientos-padron', name: 'Pimientos de Padrón' },
            { id: 'tapas-tortilla-espanola', name: 'Tortilla Española' },
            { id: 'tapas-pan-con-tomate', name: 'Pan con Tomate' },
        ],
    },
    tunisianSaleeType: {
        id: 'tunisian-salee-type',
        name: 'Variety',
        options: [
            { id: 'salee-brik', name: 'Mini Brik a l\'oeuf' },
            { id: 'salee-fricasse', name: 'Mini Fricassé' },
            { id: 'salee-kaak-waraqa', name: 'Kaak Warka Salé' },
            { id: 'salee-tajine', name: 'Mini Tajine El Bey' },
            { id: 'salee-mechouia', name: 'Mechouia on Toast' },
        ],
    },
    // Confectionery Corner
    chocolateCenter: {
        id: 'chocolate-center',
        name: 'Center',
        options: [
            { id: 'chocolate-center-none', name: 'None (Solid)' },
            { id: 'chocolate-center-fondant', name: 'Fondant Heart' },
            { id: 'chocolate-center-croquant', name: 'Croquant Heart' },
        ],
    },
    chocolateType: {
        id: 'chocolate-type',
        name: 'Chocolate Type',
        options: [
            { id: 'chocolate-type-white', name: 'White Chocolate' },
            { id: 'chocolate-type-milk-35', name: 'Milk Chocolate (35%)' },
            { id: 'chocolate-type-milk-45', name: 'Milk Chocolate (45%)' },
            { id: 'chocolate-type-dark-60', name: 'Dark Chocolate (60%)' },
            { id: 'chocolate-type-dark-75', name: 'Dark Chocolate (75%)' },
            { id: 'chocolate-type-dark-85', name: 'Dark Chocolate (85%)' },
        ],
    },
    chocolateFlavor: {
        id: 'chocolate-flavor',
        name: 'Flavor Infusion',
        options: allFlavors,
    },
    tunisianSweetsType: {
        id: 'tunisian-sweets-type',
        name: 'Variety',
        options: [
            { id: 'sweet-kaak-warka', name: 'Kaak Warka' },
            { id: 'sweet-baklawa', name: 'Baklawa' },
            { id: 'sweet-samsa', name: 'Samsa' },
            { id: 'sweet-mlabes', name: 'Mlabes' },
            { id: 'sweet-ghraiba', name: 'Ghraiba' },
        ],
    },
    tunisianSweetsNuts: {
        id: 'tunisian-sweets-nuts',
        name: 'Nut Variety',
        isMultiSelect: true,
        options: [
            { id: 'nut-almond', name: 'Almond', label: 'Almond' },
            { id: 'nut-hazelnut', name: 'Hazelnut', label: 'Hazelnut' },
            { id: 'nut-walnut', name: 'Walnut', label: 'Walnut' },
            { id: 'nut-pinenut', name: 'Pine Nut', label: 'Pine Nut' },
            { id: 'nut-pistachio', name: 'Pistachio', label: 'Pistachio' },
        ]
    },
    ghraibaFlourType: {
        id: 'ghraiba-flour-type',
        name: 'Flour Type (Ghraiba only)',
        options: [
            { id: 'flour-chickpea', name: 'Chickpea' },
            { id: 'flour-wheat', name: 'Wheat' },
            { id: 'flour-sorghum', name: 'Sorghum' },
        ]
    },
    candyType: {
        id: 'candy-type',
        name: 'Candy Type',
        options: [
            { id: 'candy-gummies', name: 'Fruity Gummies' },
            { id: 'candy-hard', name: 'Hard Candies' },
            { id: 'candy-lollipops', name: 'Artisanal Lollipops' },
            { id: 'candy-caramels', name: 'Salted Caramels' },
            { id: 'candy-truffles', name: 'Chocolate Truffles' },
        ],
    },
    // Burgers
    burgerBun: {
        id: 'burger-bun',
        name: 'Bun',
        options: [
            { id: 'bun-brioche', name: 'Brioche' },
            { id: 'bun-whole-wheat', name: 'Whole Wheat' },
            { id: 'bun-cereal', name: 'Cereal' },
            { id: 'bun-ciabatta', name: 'Ciabatta' },
            { id: 'bun-baguette', name: 'Baguette' },
        ],
    },
    burgerMeatType: {
        id: 'burger-meat-type',
        name: 'Meat Type',
        options: [
            { id: 'meat-beef', name: 'Beef' },
            { id: 'meat-angus-beef', name: 'Angus Beef' },
            { id: 'meat-chicken', name: 'Chicken' },
            { id: 'meat-pork', name: 'Pork' },
            { id: 'meat-lamb', name: 'Lamb' },
            { id: 'meat-fish', name: 'Fish' },
            { id: 'meat-king-prawns', name: 'King Prawns' },
            { id: 'meat-calamari', name: 'Calamari' },
            { id: 'meat-crab', name: 'Crab' },
            { id: 'meat-veggie', name: 'Veggie Patty (Vegan)' },
        ],
    },
    burgerMeatStyle: {
        id: 'burger-meat-style',
        name: 'Meat Style',
        options: [
            { id: 'style-patty', name: 'Patty' },
            { id: 'style-pulled', name: 'Pulled' },
            { id: 'style-fried', name: 'Fried' },
            { id: 'style-steak', name: 'Steak Filet' },
        ],
    },
    burgerSauces: {
        id: 'burger-sauces',
        name: 'Sauces',
        isMultiSelect: true,
        options: [
            { id: 'sauce-ketchup', name: 'Ketchup', label: 'Ketchup' },
            { id: 'sauce-mayonnaise', name: 'Mayonnaise', label: 'Mayonnaise' },
            { id: 'sauce-mustard', name: 'Mustard', label: 'Mustard' },
            { id: 'sauce-bbq', name: 'BBQ', label: 'BBQ' },
            { id: 'sauce-andalouse', name: 'Andalouse', label: 'Andalouse' },
            { id: 'sauce-samourai', name: 'Samourai', label: 'Samourai' },
        ],
    },
    burgerToppings: {
        id: 'burger-toppings',
        name: 'Toppings',
        isMultiSelect: true,
        options: [
            { id: 'topping-lettuce', name: 'Lettuce', label: 'Lettuce' },
            { id: 'topping-tomato', name: 'Tomato', label: 'Tomato' },
            { id: 'topping-onion', name: 'Onion', label: 'Onion' },
            { id: 'topping-pickles', name: 'Pickles', label: 'Pickles' },
            { id: 'topping-cheese', name: 'Cheese', label: 'Cheese' },
            { id: 'topping-bacon', name: 'Bacon', label: 'Bacon' },
        ],
    },
    // Fries
    friesType: {
        id: 'fries-type',
        name: 'Type of Fries',
        options: [
            { id: 'fries-classic', name: 'Classic Fries' },
            { id: 'fries-sweet-potato', name: 'Sweet Potato Fries' },
            { id: 'fries-wedges', name: 'Potato Wedges' },
            { id: 'fries-truffle', name: 'Truffle Parmesan Fries' },
        ],
    },
    friesDippingSauces: {
        id: 'fries-dipping-sauces',
        name: 'Dipping Sauces',
        isMultiSelect: true,
        options: [
            { id: 'sauce-ketchup', name: 'Ketchup', label: 'Ketchup' },
            { id: 'sauce-mayonnaise', name: 'Mayonnaise', label: 'Mayonnaise' },
            { id: 'sauce-aioli', name: 'Garlic Aioli', label: 'Garlic Aioli' },
            { id: 'sauce-bbq', name: 'BBQ', label: 'BBQ' },
            { id: 'sauce-cheese', name: 'Cheese Sauce', label: 'Cheese Sauce' },
        ],
    },
    // Sushi
    sushiType: {
        id: 'sushi-type',
        name: 'Sushi Type',
        options: [
            { id: 'sushi-type-nigiri', name: 'Nigiri' },
            { id: 'sushi-type-maki', name: 'Maki' },
            { id: 'sushi-type-sashimi', name: 'Sashimi' },
            { id: 'sushi-type-uramaki', name: 'Uramaki (Inside-Out Roll)' },
        ],
    },
    sushiFilling: {
        id: 'sushi-filling',
        name: 'Main Filling/Topping',
        options: [
            { id: 'sushi-filling-tuna', name: 'Tuna (Maguro)' },
            { id: 'sushi-filling-salmon', name: 'Salmon (Sake)' },
            { id: 'sushi-filling-shrimp', name: 'Shrimp (Ebi)' },
            { id: 'sushi-filling-eel', name: 'Eel (Unagi)' },
            { id: 'sushi-filling-avocado', name: 'Avocado (Vegan)' },
            { id: 'sushi-filling-cucumber', name: 'Cucumber (Kappa, Vegan)' },
            { id: 'sushi-filling-crab', name: 'Crab Stick (Kani)' },
        ],
    },
    // Pasta
    pastaStyle: {
        id: 'pasta-style',
        name: 'Pasta Style',
        options: [
            { id: 'pasta-style-classic', name: 'Classic Pasta' },
            { id: 'pasta-style-ravioli', name: 'Filled Ravioli' },
        ],
    },
    pastaShape: {
        id: 'pasta-shape',
        name: 'Pasta Shape',
        options: [
            { id: 'pasta-shape-penne', name: 'Penne' },
            { id: 'pasta-shape-spaghetti', name: 'Spaghetti' },
            { id: 'pasta-shape-fusilli', name: 'Fusilli' },
            { id: 'pasta-shape-tagliatelle', name: 'Tagliatelle' },
        ],
    },
    pastaSauce: {
        id: 'pasta-sauce',
        name: 'Sauce',
        options: [
            { id: 'pasta-sauce-marinara', name: 'Marinara (Vegan)' },
            { id: 'pasta-sauce-alfredo', name: 'Alfredo' },
            { id: 'pasta-sauce-pesto', name: 'Pesto' },
            { id: 'pasta-sauce-bolognese', name: 'Bolognese' },
            { id: 'pasta-sauce-carbonara', name: 'Carbonara' },
        ],
    },
    ravioliFilling: {
        id: 'ravioli-filling',
        name: 'Ravioli Filling',
        options: [
            { id: 'ravioli-filling-cheese', name: 'Four Cheese' },
            { id: 'ravioli-filling-spinach', name: 'Spinach & Ricotta' },
            { id: 'ravioli-filling-beef', name: 'Braised Beef' },
            { id: 'ravioli-filling-mushroom', name: 'Wild Mushroom' },
        ],
    },
};

    

    